import { format, formatISO, parseISO } from 'date-fns';
import React, { useContext } from 'react';
import { LocaleContext } from '@eas/common-web';
import { HistoryFieldProps } from '../history-types';
import { StringHistoryField } from './string-history-field';

export function parseISOTime(time: string) {
  const now = new Date();
  const dateTime = formatISO(now, { representation: 'date' }) + 'T' + time;
  return parseISO(dateTime);
}

export function LocalDateTimeHistoryField({
  value,
  position,
}: HistoryFieldProps<string>) {
  const { locale } = useContext(LocaleContext);

  const formattedValue = value
    ? format(parseISO(value), locale.dateTimeFormat)
    : undefined;

  return <StringHistoryField value={formattedValue} position={position} />;
}
